import * as React from 'react';
import { FC } from 'react';

import { Box, BoxProps, makeUclComponent } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

interface IProgressMeter {
  percentage: number;
  _progress?: BoxProps;
}

const Wrapper = Box.withConfig({
  width: '100%',
  height: '8px',
  borderRadius: '10px',
  borderWidth: '1px',
  borderColor: primitive.$greyFour,
  background: primitive.$greyFour,
});

const Progress = Box.withConfig<{ percentage: number }>(p => ({
  borderRadius: '10px',
  height: '100%',
  width: `${p.percentage}%`,
  background: p.background ?? primitive.$fieryRed,
  // TODO: RN - Add animation
}));

const ProgressMeterComponent: FC<React.PropsWithChildren<IProgressMeter>> = ({
  percentage,
  _progress,
  ...props
}) => {
  return (
    <Wrapper {...props}>
      <Progress percentage={percentage} {..._progress} />
    </Wrapper>
  );
};

export const ProgressMeter = makeUclComponent(ProgressMeterComponent);
